// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { FacilityModel } from '../_models/facility.model';
import { QueryParamsModel } from '../../_base/crud';
// Models

export enum FacilityActionTypes {
  //[] To disperse these acyions for any reducers that follows
  FacilityOnServerCreated = '[Edit Facility Dialog] Facility On Server Created',
  FacilityCreated = '[Edit Facility Dialog] Facility Created',
  FacilityOnServerUpdated = '[Edit Facility Dialog] Facility On Server Updated',
  FacilityUpdated = '[Edit Facility Dialog] Facility Updated',
  FacilityStatusOnServerUpdated = '[Facility List Page] Facility Status On Server Updated',
  FacilityStatusUpdated = '[Facility List Page] Facility Status Updated',
  FacilitiesStatusOnServerUpdated = '[Facility List Page] Facilities Status On Server Updated',
  FacilitiesStatusUpdated = '[Facility List Page] Facilities Status Updated',
  OneFacilityOnServerDeleted = '[Facilities List Page] One Facility On Server Deleted',
  OneFacilityDeleted = '[Facilities List Page] One Facility Deleted',
  ManyFacilitiesOnServerDeleted = '[Facilities List Page] Many Facilities On Server Deleted',
  ManyFacilitiesDeleted = '[Facilities List Page] Many Facilities Deleted',
  FacilitiesPageRequested = '[Facilities List Page] Facilities Page Requested',
  FacilitiesPageLoaded = '[Facilities API] Facilities Page Loaded',
  FacilitiesPageCancelled = '[Facilities API] Facilities Page Cancelled',
  FacilitiesPageToggleLoading = '[Facilities] Facilities Page Toggle Loading',
  FacilityActionToggleLoading = '[Facilities] Facilities Action Toggle Loading',
  ThrowFacilityError = '[Offices] Throw Facility Error',
  ClearFacilityErrors = '[Offices] Clear Facility Errors',
}

export class FacilityOnServerCreated implements Action {
  readonly type = FacilityActionTypes.FacilityOnServerCreated;
  constructor(public payload: { facility: FacilityModel }) {}
}

export class FacilityCreated implements Action {
  readonly type = FacilityActionTypes.FacilityCreated;

  constructor(public payload: { facility: FacilityModel }) {}
}

export class FacilityOnServerUpdated implements Action {
  readonly type = FacilityActionTypes.FacilityOnServerUpdated;

  constructor(
    public payload: {
      partialFacility: Update<FacilityModel>; // For State update
      facility: FacilityModel; // For Server update (through service)
    },
  ) {}
}

export class FacilityUpdated implements Action {
  readonly type = FacilityActionTypes.FacilityUpdated;

  constructor(
    public payload: {
      partialFacility: Update<FacilityModel>; // For State update
      facility: FacilityModel; // For Server update (through service)
    },
  ) {}
}

export class FacilityStatusOnServerUpdated implements Action {
  readonly type = FacilityActionTypes.FacilityStatusOnServerUpdated;

  constructor(
    public payload: {
      facility: FacilityModel;
      id: number;
      is_active: boolean;
    },
  ) {}
}

export class FacilityStatusUpdated implements Action {
  readonly type = FacilityActionTypes.FacilityStatusUpdated;

  constructor(
    public payload: {
      facility: FacilityModel;
      id: number;
      is_active: boolean;
    },
  ) {}
}

export class FacilitiesStatusOnServerUpdated implements Action {
  readonly type = FacilityActionTypes.FacilitiesStatusOnServerUpdated;

  constructor(
    public payload: {
      facilities: FacilityModel[];
      ids: number[];
      is_active: boolean;
    },
  ) {}
}

export class FacilitiesStatusUpdated implements Action {
  readonly type = FacilityActionTypes.FacilitiesStatusUpdated;

  constructor(
    public payload: {
      facilities: FacilityModel[];
      ids: number[];
      is_active: boolean;
    },
  ) {}
}

export class OneFacilityOnServerDeleted implements Action {
  readonly type = FacilityActionTypes.OneFacilityOnServerDeleted;

  constructor(public payload: { id: number }) {}
}

export class OneFacilityDeleted implements Action {
  readonly type = FacilityActionTypes.OneFacilityDeleted;

  constructor(public payload: { id: number }) {}
}

export class ManyFacilitiesOnServerDeleted implements Action {
  readonly type = FacilityActionTypes.ManyFacilitiesOnServerDeleted;

  constructor(public payload: { ids: number[] }) {}
}

export class ManyFacilitiesDeleted implements Action {
  readonly type = FacilityActionTypes.ManyFacilitiesDeleted;

  constructor(public payload: { ids: number[] }) {}
}

export class FacilitiesPageRequested implements Action {
  readonly type = FacilityActionTypes.FacilitiesPageRequested;

  constructor(public payload: { page: QueryParamsModel }) {}
}

export class FacilitiesPageLoaded implements Action {
  readonly type = FacilityActionTypes.FacilitiesPageLoaded;

  constructor(
    public payload: { facilities: FacilityModel[]; totalCount: number; page: QueryParamsModel },
  ) {}
}

export class FacilitiesPageCancelled implements Action {
  readonly type = FacilityActionTypes.FacilitiesPageCancelled;
}

export class FacilitiesPageToggleLoading implements Action {
  readonly type = FacilityActionTypes.FacilitiesPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class FacilityActionToggleLoading implements Action {
  readonly type = FacilityActionTypes.FacilityActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class ThrowFacilityError implements Action {
  readonly type = FacilityActionTypes.ThrowFacilityError;

  constructor(public payload: { error: any }) {}
}

export class ClearFacilityErrors implements Action {
  readonly type = FacilityActionTypes.ClearFacilityErrors;
}

export type FacilityActions =
  | FacilityOnServerCreated
  | FacilityCreated
  | FacilityOnServerUpdated
  | FacilityUpdated
  | FacilityStatusOnServerUpdated
  | FacilityStatusUpdated
  | FacilitiesStatusOnServerUpdated
  | FacilitiesStatusUpdated
  | OneFacilityOnServerDeleted
  | OneFacilityDeleted
  | ManyFacilitiesOnServerDeleted
  | ManyFacilitiesDeleted
  | FacilitiesPageRequested
  | FacilitiesPageLoaded
  | FacilitiesPageCancelled
  | FacilitiesPageToggleLoading
  | FacilityActionToggleLoading
  | ThrowFacilityError
  | ClearFacilityErrors;
